import { FaAws, FaCss3, FaNode, FaReact, FaSass, FaFigma, FaPhoneAlt, FaUser, FaMapMarkerAlt, FaPaperPlane, FaFutbol, FaInstagram, FaLinkedin } from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { SiTypescript } from "react-icons/si";
import { BsMedium } from "react-icons/bs";
import portfolio from "./assets/portfolio.jpg"
import work1 from "./assets/work1.png";
import work2 from "./assets/work2.png";
import work3 from "./assets/work3.png";
import work4 from "./assets/work4.png";
import work5 from "./assets/work5.png";
import work6 from "./assets/work6.png";
import work7 from "./assets/work7.png";
import work8 from "./assets/work8.png";
import work9 from "./assets/work9.png";
import work10 from "./assets/work10.png";
import work11 from "./assets/work11.png";
import work12 from "./assets/work12.png";

export const navLinks = ["home", "about", "skills", "portfolio", "contact"]


const handleClickInsta = () => {
  window.open("https://www.instagram.com/vihaanshahh/", "_blank");
}


const handleClickLinked = () => {
  window.open("https://www.linkedin.com/in/vihaanshah04/", "_blank");
}

export const socialIcons = [

  <FaFutbol />,
  <a style={{color: "gray"}} href="#" onClick={handleClickInsta}>
  <FaInstagram/>
  </a>,
  <a style={{color: "gray"}} href="#" onClick={handleClickLinked}>
  <FaLinkedin />
  </a>,
]

export const bios = [
  {
    id: 1,
    icon: <FaUser />,
    key: "Name",
    value: "Vihaan Shah"
  },
  {
    id: 2,
    icon: <FaPhoneAlt />,
    key: "Phone",
    value: "+1(732)6779037"
  },
  {
    id: 3,
    icon: <FaPaperPlane />,
    key: "Email",
    value: "vihaan.shah2014@gmail.com"
  }
]

export const icons = [<FaAws />, <FaCss3 />, <DiJavascript />, <SiTypescript />, <FaReact />, <FaNode />, <FaSass />, <FaFigma />]

export const experiences = [
  {
    id: 1,
    year: "2023",
    position: "Information Technology Help Desk",
    company: "myrbs.business.rutgers.edu/otis"
  },
  {
    di: 2,
    year: "2020-2022",
    position: "General Manager",
    company: "www.njstem.net"
  },
  {
    id: 3,
    year: "2022",
    position: "Sales Associate",
    company: "www.bjs.com"
  },  {
    id: 4,
    year: "2016-2019",
    position: "Camp Counselor",
    company: "www.engineeringforkids.com"
  }
]
export const finishes = [
  {
    id: 1,
    number: '6+',
    itemName: "Years Of Experience"
  },
  {
    id: 2,
    number: "150+",
    itemName: "Satisfied Customers"
  },
  // {
  //   id: 3,
  //   number: "100+",
  //   itemName: "Designed Items"
  // },
  {
    id: 4,
    number: "117+",
    itemName: "Clients Served"
  }
]
export const workImages = [
  {
    id: 1,
    img: work1,
    name: "NJ Stem",
    category: "Professional",
    link1: "https://github.com/vihaanshah2014",
    link2: "https://njstem.net/"
  },
  {
    id: 2,
    img: work2,
    name: "Aeron Armeson",
    category: "Professional",
    link1: "https://github.com/vihaanshah2014/Aeron-Armison",
    link2: "https://aeron-armeson.netlify.app/"
  },
  {
    id: 3,
    img: work3,
    name: "Fan Nation",
    category: "Professional",
    link1: "https://github.com/vihaanshah2014/Fan_Nation",
    link2: "https://fannation.netlify.app/"
  },
  {
    id: 4,
    img: work4,
    name: "Chrome Rose",
    category: "projects",
    link1: "https://github.com/vihaanshah2014/Chatroom",
    link2: "https://chromerose.netlify.app/"
  },
  {
    id: 5,
    img: work5,
    name: "Wordle",
    category: "projects",
    link1: "https://github.com/vihaanshah2014/WorkingWordle",
    link2: "https://wordleee.netlify.app/"
  },
  {
    id: 6,
    img: work6,
    category: "projects",
    link1: "https://github.com/vihaanshah2014/Tetris",
    link2: "https://chromerose2.netlify.app/"
  },
  {
    id: 7,
    img: work7,
    category: "projects",
    link1: "https://github.com/vihaanshah2014/krishnagpt",
    link2: "https://krishnagpt.netlify.app/"
  },
  {
    id: 8,
    img: work8,
    category: "projects",
    link1: "https://github.com/vihaanshah2014/homepage",
    link2: "https://vihaansdashboard.netlify.app/"
  },
  {
    id: 9,
    img: work9,
    category: "projects",
    link1: "https://github.com/vihaanshah2014/vihaanpics",
    link2: "https://vihaanpics.netlify.app/"
  },
  {
    id: 10,
    img: work10,
    category: "projects",
    link1: "https://github.com/vihaanshah2014/bhajans",
    link2: "https://bhajansvs.netlify.app"
  },
  {
    id: 11,
    img: work11,
    category: "Professional",
    link1: "https://github.com/vihaanshah2014/velocityai-landing-page",
    link2: "https://velocityai.netlify.app"
  },
  {
    id: 12,
    img: work12,
    category: "Professional",
    link1: "https://github.com/vihaanshah2014/NJ-STEM",
    link2: "https://njstemgames.netlify.app"
  }
]


export const workNavs = [
  "All", "Professional", "Projects"
]

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "Princeton, New Jersey"
  },
  {
    id: 2,
    icon: <FaPaperPlane />,
    infoText: "vihaan.shah2014@gmail.com"
  },
  {
    id: 3,
    icon: <FaPhoneAlt />,
    infoText: "+1(732)6779037"
  }
]
